import { makeObservable } from "mobx";
import { View } from "tamagui";
import type { Api } from "../../../core/apis";
import type { Stores } from "../../../core/stores";
import BaseModuleDataModel, {
  type BaseModuleModelData,
} from "../../core/BaseModuleDataModel";

export interface PollVoteModelData extends BaseModuleModelData {
  userId: string;
  votes: string[];
}

export default class PollVoteModel extends BaseModuleDataModel<PollVoteModelData> {
  constructor(stores: Stores, api: Api, data: PollVoteModelData) {
    super(stores, api, data);

    makeObservable(this);
  }

  toFireStore(): Omit<PollVoteModelData, "uid"> {
    return {
      ...this.fromBaseModel(),
      ...super.toFireStore(),
      ...this.data,
    };
  }

  render() {
    return <View />;
  }

  static is(
    module: BaseModuleDataModel<BaseModuleModelData>,
  ): module is PollVoteModel {
    return module instanceof PollVoteModel;
  }
}
